const checkUserHasAccount = (userData) => {
  return userData && userData.user_account_info && Object.keys(userData.user_account_info).length > 0
}

const checkUserHasSubscription = (userData) => {
  return userData && userData.user_account_info && Object.keys(userData.user_account_info).length > 0 && userData.has_active_subscription
}

export { checkUserHasAccount, checkUserHasSubscription }